import {} from '@abstract-foundation/agw-client/sessions';
import { useMutation } from '@tanstack/react-query';
import {} from 'viem';
import { useConfig } from 'wagmi';
import { createSessionMutationOptions, } from '../query/createSession.js';
export function useCreateSession(parameters = {}) {
    const { mutation } = parameters;
    const config = useConfig(parameters);
    const mutationOptions = createSessionMutationOptions(config);
    const { mutate, mutateAsync, ...result } = useMutation({
        ...mutation,
        ...mutationOptions,
    });
    return {
        ...result,
        createSession: mutate,
        createSessionAsync: mutateAsync,
    };
}
//# sourceMappingURL=useCreateSession.js.map